
import React from "react";
import { Card, CardContent } from "@/components/ui/card";

const Benefits2 = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-toctoc-gray-dark mb-4">
            Vantagens exclusivas para assinantes Toc Flash
          </h2>
          <p className="text-xl text-toctoc-gray-medium max-w-3xl mx-auto">
            Destaque-se da concorrência com ferramentas que elevam sua produtividade.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <Card className="border-t-4 border-t-toctoc-blue shadow-sm hover:shadow-md transition-shadow">
            <CardContent className="pt-6">
              <div className="text-center mb-4">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-toctoc-blue/10 text-toctoc-blue font-bold text-xl mb-4">
                  1
                </div>
                <h3 className="text-xl font-semibold mb-2 text-toctoc-black">
                  Edição profissional automatizada em segundos
                </h3>
                <p className="text-toctoc-gray-medium">
                  Transforme fotos simples em imagens de alto impacto com apenas alguns toques no seu celular.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-t-4 border-t-toctoc-orange shadow-sm hover:shadow-md transition-shadow">
            <CardContent className="pt-6">
              <div className="text-center mb-4">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-toctoc-orange/10 text-toctoc-orange font-bold text-xl mb-4">
                  2
                </div>
                <h3 className="text-xl font-semibold mb-2 text-toctoc-black">
                  Tarifas reduzidas para serviços fotográficos especializados
                </h3>
                <p className="text-toctoc-gray-medium">
                  Acesse nossa rede de profissionais TocTocquers com condições exclusivas para imóveis premium.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-t-4 border-t-toctoc-gray-dark shadow-sm hover:shadow-md transition-shadow md:col-span-2 lg:col-span-1">
            <CardContent className="pt-6">
              <div className="text-center mb-4">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-toctoc-gray-dark/10 text-toctoc-gray-dark font-bold text-xl mb-4">
                  3
                </div>
                <h3 className="text-xl font-semibold mb-2 text-toctoc-black">
                  Acesso antecipado ao Toc Toc CRM
                </h3>
                <p className="text-toctoc-gray-medium">
                  Experimente em primeira mão nosso sistema completo de gestão de clientes e imóveis (versão beta).
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="mt-16 bg-gradient-to-r from-toctoc-beige to-toctoc-beige/60 p-8 rounded-xl">
          <h3 className="text-xl font-bold mb-6 text-center text-toctoc-black">Flexibilidade total:</h3>
          <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <h4 className="font-semibold text-lg mb-2 text-toctoc-blue">Autonomia com IA avançada</h4>
              <p className="text-toctoc-gray-medium">
                Edite suas próprias fotos com tecnologia de ponta e mantenha total controle sobre seu material.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <h4 className="font-semibold text-lg mb-2 text-toctoc-orange">Ou delegue a especialistas com desconto</h4>
              <p className="text-toctoc-gray-medium">
                Quando necessário, contrate fotógrafos profissionais com tarifas exclusivas para assinantes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits2;
